module.exports = __webpack_public_path__ + "img/fsni_3.30181870.jpg";